/**
 * Central status → visual style mapping (spec section 42). Any module that
 * introduces new statuses (Sales Orders, Lots, Expenses, ...) adds its
 * entries here instead of hard-coding colors in a component.
 */
export interface StatusBadgeStyle {
  label: string;
  classes: string;
}

export const STATUS_BADGE_STYLES: Record<string, StatusBadgeStyle> = {
  Draft: { label: 'Draft', classes: 'bg-ink-muted/10 text-ink-secondary' },
  Open: { label: 'Open', classes: 'bg-action-light text-action' },
  'Partially Received': { label: 'Partially Received', classes: 'bg-status-warning/10 text-status-warning' },
  Received: { label: 'Received', classes: 'bg-status-success/10 text-status-success' },
  Completed: { label: 'Completed', classes: 'bg-status-success/10 text-status-success' },
  Cancelled: { label: 'Cancelled', classes: 'bg-status-danger/10 text-status-danger' },
  Confirmed: { label: 'Confirmed', classes: 'bg-ink-muted/10 text-ink-secondary' },
  Fulfilled: { label: 'Fulfilled', classes: 'bg-status-success/10 text-status-success' },

  // Sales Order item/order assignment status (spec section 16) — a separate
  // dimension from order status, so it's keyed independently here.
  Unassigned: { label: 'Unassigned', classes: 'bg-ink-muted/10 text-ink-secondary' },
  'Partially Assigned': { label: 'Partially Assigned', classes: 'bg-status-warning/10 text-status-warning' },
  'Fully Assigned': { label: 'Fully Assigned', classes: 'bg-status-success/10 text-status-success' },

  // Lot status (spec section 21).
  Available: { label: 'Available', classes: 'bg-status-success/10 text-status-success' },
  'Partially Reserved': { label: 'Partially Reserved', classes: 'bg-status-warning/10 text-status-warning' },
  Depleted: { label: 'Depleted', classes: 'bg-ink-muted/10 text-ink-secondary' },

  // Accounts Payable payment status (spec section 27).
  Paid: { label: 'Paid', classes: 'bg-status-success/10 text-status-success' },
  'Partially Paid': { label: 'Partially Paid', classes: 'bg-status-warning/10 text-status-warning' },
  Unpaid: { label: 'Unpaid', classes: 'bg-status-danger/10 text-status-danger' },
  Internal: { label: 'Internal Cost', classes: 'bg-ink-muted/10 text-ink-secondary' },

  // Credit memo status (Finance > Sales > Credits).
  Unused: { label: 'Unused', classes: 'bg-action-light text-action' },
  'Partially Applied': { label: 'Partially Applied', classes: 'bg-status-warning/10 text-status-warning' },
  Used: { label: 'Used', classes: 'bg-status-success/10 text-status-success' },

  // Customer payment processing status (Finance > Sales > Payments).
  Succeeded: { label: 'Succeeded', classes: 'bg-status-success/10 text-status-success' },
  Pending: { label: 'Pending', classes: 'bg-status-warning/10 text-status-warning' },
  Failed: { label: 'Failed', classes: 'bg-status-danger/10 text-status-danger' },
  Bounced: { label: 'Bounced', classes: 'bg-status-danger/10 text-status-danger' },
  Refunded: { label: 'Refunded', classes: 'bg-ink-muted/10 text-ink-secondary' },
  'Refund pending': { label: 'Refund pending', classes: 'bg-status-warning/10 text-status-warning' },
};

export const DEFAULT_STATUS_BADGE_STYLE: StatusBadgeStyle = {
  label: '',
  classes: 'bg-ink-muted/10 text-ink-secondary',
};
